import React from 'react';
import BlogDetailsLeftSide from '../../../components/BlogDetailsLeftSide/BlogDetailsLeftSide';
import BlogDetailsRightSide from '../../../components/BlogDetailsRightSide/BlogDetailsRightSide';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../../components/SEO/SEOHead';
import { getApplicationDetailAlternates } from '../../../utils/seoMappings';
import { shouldNoindexApplicationDetail } from '../../../utils/seoIndexing';

const BlogDetailsArea = ({ blogData }) => {
   const { i18n } = useTranslation();
   if (!blogData?.length) {
      return null;
   }

   const alternates = getApplicationDetailAlternates(blogData[0].id, i18n.language);

   return (
      <>
         <section className="blog-area pt-50 pb-80">
            <SEOHead
               title={`${blogData[0].title} | Doç. Dr. Ebru Karagün`}
               description={blogData[0].content.metaDescription}
               image={blogData[0].image}
               canonicalPath={i18n.language === 'en'
                  ? `/en/applications/${blogData[0].applicationid}/${blogData[0].id}`
                  : `/uygulamalar/${blogData[0].applicationid}/${blogData[0].id}`}
               trPath={alternates.trItem ? `/uygulamalar/${alternates.trItem.applicationid}/${alternates.trItem.id}` : null}
               enPath={alternates.enItem ? `/en/applications/${alternates.enItem.applicationid}/${alternates.enItem.id}` : null}
               noindex={shouldNoindexApplicationDetail(blogData[0].id)}
            />
            <div className="container">
               <div className="header-info position-absolute d-md-none flex" style={{ top: 65 }}>
                  <a href="tel:+903125574646"> <span><i className="fas fa-phone"></i> +90 312 557 46 46</span></a>
                  <a href="tel:+905332691271"> <span><i className="fas fa-phone"></i> +90 533 269 12 71</span></a>
               </div>
               <div className="row">

                  <BlogDetailsLeftSide blogData={blogData[0]} details_topBar={<div className="postbox__thumb mb-35">
                     <img src={blogData[0]?.image} alt={blogData[0]?.title} />
                  </div>} />

                  <BlogDetailsRightSide />

               </div>
            </div>
         </section>
      </>
   );
};

export default BlogDetailsArea;
